import React, { HTMLAttributes } from 'react'
import { FontAwesomeSvgIcon as FontAwesomeIcon } from 'react-fontawesome-svg-icon'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import clsx from 'clsx'

export interface SemanticIconProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Add an icon to the SemanticIcon
   */
  icon: IconDefinition
  /**
   * Changes the color of the SemanticIcon to match the semantic meaning of the SemanticIcon
   */
  theme?: 'none' | 'default' | 'warning' | 'success' | 'error' | 'dark' | 'neutral' | 'primary' | 'alternative'
}

export const SemanticIconStyle = {
  _: 'flex justify-center items-center leading-none rounded-full h-10 w-10',
  theme: {
    alternative: 'bg-background-alternative text-text-default',
    dark: 'bg-gray-300 text-gray-700',
    default: 'bg-gray-100 text-gray-600',
    error: 'bg-red-200 text-red-600',
    neutral: 'bg-blue-200 text-blue-600',
    none: '',
    primary: 'bg-orange-200 text-orange-600',
    success: 'bg-green-200 text-green-600',
    warning: 'bg-yellow-200 text-yellow-600'
  }
}

/**
 * SemanticIcon - Semantic state icons can be used with obvious success, error and warning state icons, but can also use icons that are relevant to the messaging being displayed
 */
export function SemanticIcon({ icon, theme = 'default', ...props }: SemanticIconProps) {
  return (
    <div {...props} className={clsx(SemanticIconStyle._, SemanticIconStyle.theme[theme], props.className)}>
      <FontAwesomeIcon icon={icon} size='lg' />
    </div>
  )
}
